import { Record } from "immutable";

export const jobStateInfoFromJSON = (json: Partial<IJobStateInfoData>): JobStateInfoRecord =>
  new JobStateInfoRecord({
    pretty_name: json.pretty_name ?? "",
    color: json.color ?? "",
    archived: json.archived ?? false,
  });

export interface IJobStateInfoData {
  pretty_name: string;
  color: string;
  /** occ-app-only, additive, schemaless — the backend ignores it. Marks a retired status. */
  archived?: boolean;
}

export interface IJobStateInfoRecord {
  pretty_name: string;
  color: string;
  archived: boolean;
}

export const defaultJobStateInfoRecord = {
  pretty_name: "",
  color: "",
  archived: false,
};

export class JobStateInfoRecord extends Record(defaultJobStateInfoRecord) implements IJobStateInfoRecord {}
